import type { AwsBody } from '@uppy/aws-s3'
import type { UppyOptions } from '@uppy/core'
import type { FC, ReactNode } from 'react'

import { IMAGE_FILE_TYPES, MAX_AWS_FILE_SIZE } from '@app/lib/globals'
import AwsUploaderModal from '@app/shared/uploader/awsUploaderModal'
import type { OnUploadSuccess } from '@app/types'

type Props = {
  children: ReactNode
  onUploadSuccess: OnUploadSuccess
}

type Meta = Record<string, unknown>

const EntityAttachmentUploadButton: FC<Props> = ({ children, onUploadSuccess }) => {
  const uppyOptions: UppyOptions<Meta, AwsBody> = {
    restrictions: {
      maxFileSize: MAX_AWS_FILE_SIZE,
      allowedFileTypes: IMAGE_FILE_TYPES,
      minFileSize: 0,
      maxTotalFileSize: 0,
      maxNumberOfFiles: 0,
      minNumberOfFiles: 0,
      requiredMetaFields: []
    }
  }

  return (
    <AwsUploaderModal onUploadSuccess={onUploadSuccess} uppyOptions={uppyOptions}>
      {children}
    </AwsUploaderModal>
  )
}

export default EntityAttachmentUploadButton
